import React, {useEffect, useState} from 'react';
import {Button, Input, Table, Tag, Popconfirm, message, notification, Popover, Select, DatePicker, Radio, Modal, Checkbox} from 'antd';
import {useAuth} from "../../contexts/AuthContext";
import {useWindowDimensions} from "../../contexts/WindowDimensionsContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faPen, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, StepBackwardOutlined, StepForwardOutlined} from "@ant-design/icons";
import axios from "axios";
import PageTitle from "../../components/PageTitle";
import CarForm from "./carForm";
import * as XLSX from "xlsx";
import saveAs from "file-saver";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {useNavigate} from "react-router-dom";
import firebaseStorage from "../../firebase";
import {deleteObject, getDownloadURL, ref, uploadBytesResumable} from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';

dayjs.extend(isBetween);

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const generateId = () => uuidv4();

export default function CarTable({ backendApiUrl }) {
    const authContext = useAuth();
    const windowDimensions = useWindowDimensions();
    const [cars, setCars] = useState([]);
    const [displayedCars, setDisplayedCars] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [customSort, setCustomSort] = useState(true);
    const [push, setPush] = useState(false);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [fileList, setFileList] = useState([])
    const [fileListToDelete, setFileListToDelete] = useState([])
    const [elementId, setElementId] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [popExportOpen, setPopExportOpen] = useState(false);
    const [exportType, setExportType] = useState("Excel");
    const [exportSelected, setExportSelected] = useState(false);
    const [exportRange, setExportRange] = useState([]);
    const [exportControls, setExportControls] = useState(false);
    const [uuid, setUuid] = useState(generateId());
    const [selectedRentals, setSelectedRentals] = useState(["all"]);
    const [selectedDisplayedRentals, setSelectedDisplayedRentals] = useState([]);
    const allRentals = [...new Set(cars.map(car => car.rentalCompany))].filter(Boolean);
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();
    const columnMapping = {
        licensePlate: "Plaque d'immatriculation",
        brand: "Marque",
        label: "Libellé",
        owner: "Propriétaire",
        rentalCompany: "Locataire",
        rentalSheet: "Contrat de location",
        report: "Constat",
        "inspection.lastPerformed": "Dernière inspection",
        "inspection.performedBy": "Inspecteur",
        "technicalReview.lastPerformed": "Dernier contrôle technique",
        "technicalReview.nextScheduled": "Prochain contrôle technique",
        insideStatus: "État intérieur",
        outsideStatus: "État extérieur",
        "availability.status": "Disponibilité",
        "availability.description": "Description Disponibilité",
        comments: "Commentaires",
    };
    const [newElement, setNewElement] = useState({
        _id: "",
        label: "",
        brand: "",
        licensePlate: "",
        report: false,
        owner: "",
        rentalCompany: "",
        rentalSheet: [],
        inspection: {
            lastPerformed: "",
            performedBy: "",
        },
        technicalReview: {
            lastPerformed: "",
            nextScheduled: "",
        },
        insideStatus: 0,
        insideStatusPictures: [],
        outsideStatus: 0,
        outsideStatusPictures: [],
        availability: {
            status: "Disponible",
            description: "",
        },
        comments: [],
    });

    useEffect(() => {
        fetchElements();
    }, []);

    const resetForm = () => {
        setUuid(generateId());
        setCurrentStep(0)
        setElementId(null);
        setFileListToDelete([])
        setFileList([])
        setNewElement({
            _id: "",
            label: "",
            brand: "",
            licensePlate: "",
            report: false,
            owner: "",
            rentalCompany: "",
            rentalSheet: [],
            inspection: {
                lastPerformed: "",
                performedBy: "",
            },
            technicalReview: {
                lastPerformed: "",
                nextScheduled: "",
            },
            insideStatus: 0,
            insideStatusPictures: [],
            outsideStatus: 0,
            outsideStatusPictures: [],
            availability: {
                status: "Disponible",
                description: "",
            },
            comments: [],
        });
    };

    const handleRentalChange = (values) => {
        if (values.includes("all")) {
            setSelectedRentals(["all"]);
        } else {
            setSelectedRentals(values.filter(v => v !== "all"));
        }
    };

    const getMonday = (date, direction = "next", minus = 0) => {
        const day = date.day();
        if (direction === "next") {
            if (minus)
                return day === 1 ? date : date.add((8 - minus) - day, "day");
            return day === 1 ? date : date.add(8 - day, "day");
        } else {
            return day === 1 ? date : date.subtract(day - 1, "day");
        }
    };

    const rangePresets = [
        { label: 'Semaine en cours', value: [dayjs(), getMonday(dayjs(), "next", 1)] },
        { label: 'Prochaine semaine', value: [getMonday(dayjs(), "next").add(6, 'day'), getMonday(dayjs(), "next")] },
        { label: '2 prochaines semaines', value: [getMonday(dayjs(), "next").add(13, 'day'), getMonday(dayjs(), "next")] },
        { label: '3 prochaines semaines', value: [getMonday(dayjs(), "next").add(20, 'day'), getMonday(dayjs(), "next")] },
        { label: '4 prochaines semaines', value: [getMonday(dayjs(), "next").add(27, 'day'), getMonday(dayjs(), "next")] },
        { label: '5 prochaines semaines', value: [getMonday(dayjs(), "next").add(34, 'day'), getMonday(dayjs(), "next")] },
        { label: '6 prochaines semaines', value: [getMonday(dayjs(), "next").add(41, 'day'), getMonday(dayjs(), "next")] },
        { label: '7 prochaines semaines', value: [getMonday(dayjs(), "next").add(48, 'day'), getMonday(dayjs(), "next")] },
        { label: '8 prochaines semaines', value: [getMonday(dayjs(), "next").add(55, 'day'), getMonday(dayjs(), "next")] },
    ];

    const handleCloseExportPop = () => {
        setPopExportOpen(false)
        setExportRange([]);
        setExportSelected(false);
        setExportType("Excel");
        setExportControls(false)
        setSelectedRentals(["all"]);
    }

    const handleExport = () => {
        if (displayedCars.length === 0) {
            alert("Aucune donnée à exporter.");
            return;
        }

        if (exportSelected || rowSelection.selectedRowKeys.length === 0) {
            if (selectedRentals.length === 0) {
                alert("Veuillez sélectionner au moins un locataire.");
                return;
            }
        }

        if (!exportType) {
            alert("Veuillez sélectionner un format d'exportation.");
            return;
        }

        const exportData = prepareExportData();

        if (exportData.length === 0) {
            alert("Aucune donnée correspondante aux critères sélectionnés.");
            return;
        }

        exportType === "Excel" ? exportToExcel() : exportToCSV();
        handleCloseExportPop();
    };

    const prepareExportData = () => {
        let filteredCars = [];

        if (!exportSelected && rowSelection.selectedRowKeys.length !== 0) {
            filteredCars = displayedCars.filter((car) =>
                rowSelection.selectedRowKeys.includes(car._id)
            );
        } else {
            filteredCars = selectedRentals.includes("all")
                ? displayedCars
                : displayedCars.filter((car) => selectedRentals.includes(car.rentalCompany));
        }

        const now = dayjs();

        const datesToCheck = [
            { type: "inspection", months: 12 },
            { type: "technicalReview", months: 12 },
            { type: "speedLimiter", months: 12 },
            { type: "tachograph", months: 24 },
            { type: "tailgates", months: 12 }
        ];

        let filteredByDateRangeOrOverdue = filteredCars;


        if ((exportSelected || rowSelection.selectedRowKeys.length === 0) && exportRange.length !== 0) {
            filteredByDateRangeOrOverdue = filteredCars.filter((car) => {
                if (!exportControls) {
                    return datesToCheck.some(({ type }) => {
                        const lastPerformedDate = car[type]?.lastPerformed ? dayjs(car[type].lastPerformed) : null;
                        return lastPerformedDate?.isValid() &&
                            lastPerformedDate.isBetween(dayjs(exportRange[0]), dayjs(exportRange[1]), "day", "[]");
                    });
                }

                return datesToCheck.some(({ type, months }) => {
                    const lastPerformedDate = car[type]?.lastPerformed ? dayjs(car[type].lastPerformed) : null;
                    if (lastPerformedDate?.isValid()) {
                        const adjustedDate = lastPerformedDate.add(months, 'month');
                        return adjustedDate.isBetween(dayjs(exportRange[0]), dayjs(exportRange[1]), "day", "[]");
                    }
                    return false;
                });
            });
        }

        return filteredByDateRangeOrOverdue.map((car) => {
            let flatCar = {};
            Object.keys(columnMapping).forEach((col) => {
                let value;
                if (col === "comments") {
                    value = car.comments.length
                        ? car.comments.map(
                            (c) => `${dayjs(c.date).format("DD/MM/YYYY")} - ${c.description} (${c.performedBy})`
                        ).join(" | ")
                        : "-";
                } else if (col.includes(".")) {
                    const keys = col.split(".");
                    value = car[keys[0]]?.[keys[1]] ?? "-";
                } else {
                    value = car[col] ?? "-";
                }
                if (col === "transpalType") {
                    value = (car.transpal && car.hasTailgates) ? (value === true ? "Électrique" : "Manuel") : "-";
                }
                if (col === "rentalSheet") {
                    value = car.rentalSheet.length !== 0 ? (value ? "Oui" : "Non") : "-";
                }
                if (col === "report") {
                    value = car.report ? (value ? "Oui" : "Non") : "-";
                }
                if (col === "logosOK") {
                    value = car.logoTeamKimmel ? (value ? "Oui" : "Non") : "-";
                }
                if (col === "insideStatus" || col === "outsideStatus") {
                    value = `${value}/10`;
                }
                if (typeof value === "boolean") {
                    value = value ? "Oui" : "Non";
                }
                const isDateLike = dayjs(value).isValid() && typeof value === "string";
                if (isDateLike && !["license", "transpalType"].includes(col)) {
                    value = dayjs(value).format("DD/MM/YYYY");
                }

                flatCar[columnMapping[col]] = value;
            });
            return flatCar;
        });
    };

    const exportToCSV = () => {
        const ws = XLSX.utils.json_to_sheet(prepareExportData());
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Voitures");
        const csvBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
        const blob = new Blob([csvBuffer], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "Voitures.csv");
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(prepareExportData());
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Voitures");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Voitures.xlsx");
    };

    const handleElementDelete = async (id) => {
        try {
            const response = await axios.get(`${backendApiUrl}/cars/id/${id ? id : elementId}`);
            const car = response.data;

            if (!car) {
                message.error("Voiture introuvable.");
                return;
            }
            const filesToDelete = [
                ...car.rentalSheet,
                ...car.report,
                ...car.outsideStatusPictures,
                ...car.insideStatusPictures,
            ];

            const deletePromises = filesToDelete.map(async (fileUrl) => {
                try {
                    const filePath = extractFirebasePath(fileUrl);
                    if (!filePath) return;

                    const fileRef = ref(firebaseStorage, filePath);
                    await deleteObject(fileRef);
                } catch (error) {
                    console.error(`Error deleting file: ${fileUrl}`, error);
                }
            });

            await Promise.all(deletePromises);
            await axios.delete(`${backendApiUrl}/cars/${id ? id : elementId}`);

            setIsOpen(false);
            resetForm();
            fetchElements();
            message.success("Voiture et fichiers supprimés avec succès !");
        } catch (error) {
            console.error("Error deleting car:", error);
            message.error("Une erreur est survenue lors de la suppression de la Voiture.");
        }
    };

    const extractFirebasePath = (url) => {
        const match = url.match(/o\/(.*?)\?/);
        return match ? decodeURIComponent(match[1]) : null;
    };

    const getStatusTagColor = (status) => {
        if (status >= 7) return 'green';   // Good (7-10)
        if (status >= 5) return 'orange';  // Medium (5-6)
        if (status >= 3) return 'red';     // Bad (3-4)
        return 'purple';                   // Horrible (0-2)
    };

    const getAvailabilityTagColor = (status) => {
        switch (status) {
            case "Disponible":
                return 'green';   // Available
            case "Maintenance programée":
                return 'orange';  // Partially Available
            case "Contre-visite":
                return 'magenta';  // Counter-visit
            case "En maintenance":
                return 'red';     // Not Available
            default:
                return 'purple'; // Unavailable for a long time
        }
    };

    const getTagColor = (date, type, isRed = false) => {
        const today = new Date();
        const diffInMs = new Date(date) - today;
        const daysDifference = diffInMs / (1000 * 3600 * 24);
        let color = 'green';
        if (isRed)
            return "magenta";
        switch (type) {
            case 'inspection':
            case 'technicalReview':
                if (daysDifference < 0) {
                    if (daysDifference <= -30) {
                        color = 'purple'; // Dépassé depuis plus d'un mois
                    } else {
                        color = 'red'; // Dépassé mais moins d'un mois
                    }
                } else if (daysDifference <= 30) {
                    color = 'orange'; // Proche de la date d'échéance
                }
                break;
            default:
                color = 'green'; // Si rien n'est précisé
        }

        return color;
    };

    const fetchElements = async () => {
        try {
            const response = await axios.get(`${backendApiUrl}/cars/`);
            if (response.status === 200 && response.data.length > 0) {
                let sortedCars = response.data;

                if (customSort) {
                    sortedCars = sortCarsByPriority(sortedCars);
                } else {
                    sortedCars.sort((a, b) => a.licensePlate.localeCompare(b.licensePlate));
                }

                setCars(response.data);
                setDisplayedCars(sortedCars);
            } else {
                setCars([]);
                setDisplayedCars([]);
            }
        } catch (error) {
            setCars([]);
            setDisplayedCars([]);
            console.error('Error fetching cars:', error);
            message.error("Une erreur est survenue lors de la récupération des Voitures.");
        }
    };

    const sortCarsByPriority = (cars) => {
        return [...cars].sort((a, b) => {
            const countColors = (car) => {
                const controls = [
                    { type: 'inspection', months: 12 },
                    { type: 'technicalReview', months: 12 },
                ];

                let purple = 0, red = 0, orange = 0, green = 0;

                controls.forEach(({ type, months }) => {
                    if (car[type]?.lastPerformed) {
                        const expiryDate = new Date(car[type].lastPerformed);
                        expiryDate.setMonth(expiryDate.getMonth() + months);

                        const color = getTagColor(expiryDate, type);
                        if (color === 'purple') purple++;
                        else if (color === 'red') red++;
                        else if (color === 'orange') orange++;
                        else green++;
                    }
                });

                return { purple, red, orange, green };
            };

            const aColors = countColors(a);
            const bColors = countColors(b);

            return (
                bColors.purple - aColors.purple || // Most purple first
                bColors.red - aColors.red ||       // Then most red
                bColors.orange - aColors.orange || // Then most orange
                bColors.green - aColors.green ||   // Then most green
                a.licensePlate.localeCompare(b.licensePlate) // Finally by license plate
            );
        });
    };

    const validateCarFields = () => {
        const errors = [];

        if (!newElement.licensePlate) errors.push("Plaque d'immatriculation");
        if (!newElement.owner) errors.push("Propriétaire du véhicule");
        if (!newElement.inspection || !newElement.inspection.lastPerformed || !newElement.inspection.performedBy) {
            errors.push("Contrôle d'inspection : Date d'inspection ou Réalisé par manquant");
        }
        if (!newElement.technicalReview || !newElement.technicalReview.lastPerformed) {
            errors.push("Révision technique : Date du dernier contrôle manquante");
        }
        if (!fileList.find(file => file.element === "insideStatusPictures")) {
            errors.push("Photos de l'intérieur : Au minimum une image requise");
        }
        if (!fileList.find(file => file.element === "outsideStatusPictures")) {
            errors.push("Photos de l'extérieur : Au minimum une image requise");
        }

        if (errors.length > 0) {
            api.error({
                message: 'Champs manquants',
                description: (
                    <div>
                        {errors.map((error, index) => (
                            <p key={index}>- {error}</p>
                        ))}
                    </div>
                ),
                duration: 7,
                style: {
                    width: 600,
                },
                showProgress: true,
            });
            return false
        }
        return true;
    };

    const handleManualDelete = async () => {
        const deletePromises = fileListToDelete.map(async (file) => {
            try {
                const fileRef = ref(firebaseStorage, file.firebaseUrl);
                await deleteObject(fileRef);
                message.success(`Le fichier ${file.name} a été supprimé avec succès.`);
                return file;
            } catch (error) {
                console.error("Erreur lors de la suppression du fichier:", error);
                return null;
            }
        });

        const deletedFiles = await Promise.all(deletePromises);
        const successfullyDeletedFiles = deletedFiles.filter(file => file !== null);
        setFileListToDelete((prev) => prev.filter((file) => !successfullyDeletedFiles.includes(file)));
        return successfullyDeletedFiles;
    };

    const handleManualUpload = () => {
        let isErrors = false;
        const updatedFiles = [];

        const uploadPromises = fileList.map(({ element, value: thisFileList }) => {
            if (!thisFileList || thisFileList.length === 0) {
                updatedFiles.push({ element, urls: [] });
                return Promise.resolve();
            }

            const existingFiles = thisFileList.filter((file) => file.status === "done");
            const filesToUpload = thisFileList.filter((file) => file.status !== "done");

            if (filesToUpload.length === 0) {
                updatedFiles.push({ element, urls: existingFiles.map((file) => file.url).filter(Boolean) });
                return Promise.resolve();
            }

            return Promise.all(filesToUpload.map((file) =>
                new Promise((resolveFile, rejectFile) => {
                    try {
                        const fileExtension = file.name.split('.').pop().toLowerCase();
                        let mimeType = 'application/octet-stream';

                        if (['webp', 'jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
                            mimeType = 'image/' + fileExtension;
                        } else if (fileExtension === 'pdf') {
                            mimeType = 'application/pdf';
                        } else if (fileExtension === 'docx') {
                            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                        }

                        const filePathIdentifier = elementId || uuid;
                        const storageRef = ref(firebaseStorage, `${element}/${filePathIdentifier}/cars/${file.name}`);

                        const metadata = {
                            contentType: mimeType,
                            customMetadata: {
                                'lastModified': file.lastModified,
                                'originalName': file.name,
                            }
                        };

                        const uploadTask = uploadBytesResumable(storageRef, file.originFileObj || file, metadata);

                        uploadTask.on(
                            "state_changed",
                            null,
                            (error) => {
                                console.error("Upload error:", error);
                                message.error(`Le téléversement du document : ${file.name} a échoué`);
                                rejectFile(error);
                            },
                            async () => {
                                try {
                                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                                    message.success(`Le téléversement du document : ${file.name} a réussi`);
                                    resolveFile({ url: downloadURL, name: file.name, status: "done" });
                                } catch (error) {
                                    console.error("Error getting download URL:", error);
                                    rejectFile(error);
                                }
                            }
                        );
                    } catch (error) {
                        console.error("Error during manual upload:", error);
                        message.error(`Erreur lors du téléversement du fichier ${file.name}`);
                        rejectFile(error);
                    }
                })
            )).then((newFiles) => {
                updatedFiles.push({ element, urls: [...existingFiles, ...newFiles.map(f => f.url)] });
            }).catch((error) => {
                console.error("Error uploading files for", element, error);
                isErrors = true;
            });
        });

        return Promise.all(uploadPromises)
            .then(() => (isErrors ? null : updatedFiles))
            .catch((error) => {
                console.error("Error during upload process", error);
                message.error("Erreur lors du processus de téléversement.");
                return null;
            });
    };

    useEffect(() => {
        if (newElement && push && newElement.licensePlate !== "") {
            if (elementId) {
                axios.put(`${backendApiUrl}/cars/${elementId}`, newElement, {
                    headers: { "Content-Type": "application/json" },
                })
                    .then(() => {
                        setIsOpen(false);
                        setPush(false);
                        resetForm();
                        fetchElements();
                    })
                    .catch((error) => {
                        setPush(false);
                        console.error("Error submitting car:", error);
                        message.error("Une erreur est survenue lors de l'enregistrement de la Voiture.");
                    });
            } else {
                const payload = { ...newElement, _id: uuid };
                axios.post(`${backendApiUrl}/cars/`, payload, {
                    headers: { "Content-Type": "application/json" },
                })
                    .then(() => {
                        setIsOpen(false);
                        setPush(false);
                        resetForm();
                        fetchElements();
                    })
                    .catch((error) => {
                        setPush(false);
                        console.error("Error submitting car:", error);
                        message.error("Une erreur est survenue lors de l'enregistrement de la Voiture.");
                    });
            }
        }
    }, [newElement]);

    const handleElementSubmit = async (event) => {
        return new Promise((resolve, reject) => {
            event?.preventDefault();
            if (!validateCarFields())
                return reject();

            setNewElement((prevState) => {
                const newState = { ...prevState };

                if (!elementId && !newState._id) {
                    newState._id = uuid;
                }

                return newState;
            });

            handleManualDelete()
                .then((deletedFiles) => {
                    if (deletedFiles || deletedFiles.length !== 0) {
                        setNewElement((prevState) => {
                            const newState = JSON.parse(JSON.stringify(prevState));

                            deletedFiles.forEach((file) => {
                                if (Array.isArray(newState[file.element])) {
                                    newState[file.element] = newState[file.element].filter(
                                        (url) => {
                                            return url.toString().split("?")[0] !== file.firebaseUrl.toString().split("?")[0];
                                        }
                                    );
                                } else {
                                    console.warn(`⚠️ Clé invalide ou vide : ${file.element}`);
                                }
                            });

                            return newState;
                        });
                    }
                    setFileListToDelete([]);
                    return handleManualUpload()
                })
                .then((uploadedFiles) => {
                    if (!uploadedFiles)
                        return resolve();

                    setNewElement((prevState) => {
                        const newState = JSON.parse(JSON.stringify(prevState));
                        uploadedFiles.forEach(({ element, urls }) => {
                            if (Array.isArray(urls)) {
                                const existingUrls = new Set(newState[element]?.map((url) => url.toString().split("?")[0]).filter(Boolean));
                                const uniqueUrls = urls.filter((url) => {
                                    const baseUrl = url.toString().split("?")[0];
                                    return !existingUrls.has(baseUrl);
                                });

                                if (Array.isArray(newState[element])) {
                                    newState[element] = [...newState[element], ...uniqueUrls];
                                } else {
                                    newState[element] = uniqueUrls;
                                }
                            }
                        });

                        return newState;
                    });

                    setPush(true);
                    return resolve()
                })
                .catch((error) => {
                    console.error("Erreur lors du processus d'upload/suppression :", error);
                    return reject("Une erreur est survenue lors du téléversement ou de la suppression des fichiers.")
                });
        }).catch((reason) => {reason && message.error(reason)})
    };

    const handleMultipleElementDelete = async (selectedKeys) => {
        try {
            selectedKeys.selectedRowKeys.map((id) =>
                handleElementDelete(id)
            )
            setSelectedRowKeys([]);
            fetchElements();
        } catch (error) {
            console.error("Error deleting cars:", error);
            message.error("Une erreur est survenue lors de la suppression des Voitures.");
        }
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
    };

    const handleSearch = (searchValueParam = search, rentalSelectionParam = selectedDisplayedRentals) => {
        let filteredCars = [...cars];

        if (rentalSelectionParam.length > 0) {
            filteredCars = filteredCars.filter((car) =>
                rentalSelectionParam.includes(car.rentalCompany)
            );
        }

        const searchValue = searchValueParam.toLowerCase().trim();
        if (searchValue) {
            filteredCars = filteredCars.filter((car) => {
                return Object.entries(car).some(([key, val]) => {
                    if (typeof val === "object" && val !== null) {
                        return Object.entries(val).some(([subKey, subVal]) => {
                            if (
                                subVal instanceof Date ||
                                (typeof subVal === "string" &&
                                    /\d{4}-\d{2}-\d{2}T/.test(subVal))
                            ) {
                                const formattedDate = dayjs(subVal).format("DD/MM/YYYY");
                                return formattedDate === searchValue;
                            }
                            return String(subVal).toLowerCase().includes(searchValue);
                        });
                    }
                    if (
                        val instanceof Date ||
                        (typeof val === "string" && /\d{4}-\d{2}-\d{2}T/.test(val))
                    ) {
                        const formattedDate = dayjs(val).format("DD/MM/YYYY");
                        return formattedDate === searchValue;
                    }
                    if (
                        (key === "insideStatus" || key === "outsideStatus") &&
                        typeof val === "number"
                    ) {
                        return `${val} / 10` === searchValue;
                    }
                    if (typeof val === "string") {
                        return val.toLowerCase().includes(searchValue);
                    }

                    return String(val).toLowerCase().includes(searchValue);
                });
            });
        }

        const orderedCars = customSort
            ? sortCarsByPriority(filteredCars)
            : filteredCars.sort((a, b) =>
                a.licensePlate.localeCompare(b.licensePlate)
            );

        setDisplayedCars(orderedCars);
    };

    const columns = [
        {
            title: "Plaque",
            dataIndex: "licensePlate",
            key: "licensePlate",
            locale: {
                filterTitle: 'Filtres',
                filterConfirm: 'OK',
                filterReset: 'Réinitialiser',
                emptyText: 'Aucun résultat',
            },
            showSorterTooltip: false,
            sorter: () => {},
            className: "cursor-pointer",
            onHeaderCell: () => ({
                onClick: () => {
                    setCustomSort(!customSort);
                    fetchElements();
                }
            }),
        },
        { title: "Marque", dataIndex: 'brand', key: 'brand' },
        { title: "Libellé", dataIndex: 'label', key: 'label' },
        {
            title: "Inspection",
            dataIndex: ['inspection', 'lastPerformed'],
            key: 'inspection.lastPerformed',
            render: (_, record) => {
                if (record.inspection.lastPerformed) {
                    const newDate = new Date(record.inspection.lastPerformed);
                    newDate.setMonth(newDate.getMonth() + 12);

                    return (
                        <Tag color={getTagColor(newDate,  'inspection')}>
                            {newDate.toLocaleDateString()}
                        </Tag>
                    );
                }
                return "-";
            }
        },
        {
            title: "Contrôle technique",
            dataIndex: ['technicalReview', 'lastPerformed'],
            key: 'technicalReview.lastPerformed',
            render: (_, record) => {
                if (record.technicalReview.lastPerformed) {
                    const newDate = new Date(record.technicalReview.lastPerformed);
                    newDate.setMonth(newDate.getMonth() + 12);

                    return (
                        <Tag color={getTagColor(newDate, 'technicalReview')}>
                            {newDate.toLocaleDateString()}
                        </Tag>
                    );
                }
                return "-";
            }
        },
        {
            title: "État Intérieur",
            dataIndex: 'insideStatus',
            key: 'insideStatus',
            render: (status) => (<Tag color={getStatusTagColor(status)}>{status} / 10</Tag>)
        },
        {
            title: "État Extérieur",
            dataIndex: 'outsideStatus',
            key: 'outsideStatus',
            render: (status) => (<Tag color={getStatusTagColor(status)}>{status} / 10</Tag>)
        },
        {
            title: "Disponibilité",
            dataIndex: ['availability', 'status'],
            key: 'availability.status',
            render: (status) => (<Tag color={getAvailabilityTagColor(status)}>{status}</Tag>)
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <div className={"flex gap-2"}>
                    {(authContext.currentUser?.isSuperAdmin || authContext.currentUser?.isAdmin) && <Popconfirm
                        title="Supprimer le véhicule"
                        description="Êtes-vous sûr de vouloir le supprimer ?"
                        okText="Oui"
                        cancelText="Non"
                        onConfirm={() => handleElementDelete(record._id ? record._id : "")}
                    >
                        <Button icon={<FontAwesomeIcon icon={faTrash} />} danger />
                    </Popconfirm>}
                    {(authContext.currentUser?.isSuperAdmin || authContext.currentUser?.isAdmin) && <Button icon={<FontAwesomeIcon icon={faPen} />} onClick={() => { setIsOpen(true); setNewElement(record); setElementId(record._id) }} />}
                    <Button icon={<FontAwesomeIcon icon={faEye} />} onClick={() => { navigate("/car-details?plate=" + record.licensePlate) }} />
                </div>
            ),
        },
        Table.SELECTION_COLUMN,
    ];

    return (
        <>
            {contextHolder}
            <div className={"mb-auto"}>
                <div style={{ marginBottom: "30px", width: "100%" }}>
                    <div className={"w-100 flex justify-between gap-2 flex-wrap"}>
                        <div className={"flex gap-5 flex-wrap flex-center"}>
                            <PageTitle title={"Voitures"}></PageTitle>
                            {(authContext.currentUser?.isSuperAdmin || authContext.currentUser?.isAdmin) && (
                                <Button type={"primary"} icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setIsOpen(true)}>
                                    Ajouter une Voiture
                                </Button>
                            )}
                            {selectedRowKeys.length > 0 && (authContext.currentUser?.isSuperAdmin || authContext.currentUser?.isAdmin) && (
                                <Popconfirm
                                    title="Supprimer les Voitures"
                                    description="Êtes vous sur de vouloir les supprimer ?"
                                    okText="Oui"
                                    cancelText="Non"
                                    onConfirm={() => {handleMultipleElementDelete(rowSelection); setSelectedRowKeys([])}}
                                >
                                    <Button
                                        icon={<FontAwesomeIcon icon={faTrash} />}
                                        danger
                                    >
                                        Supprimer les éléments sélectionnés
                                    </Button>
                                </Popconfirm>
                            )}
                        </div>
                        <div className={`flex gap-2 w-max-content ${windowDimensions.wWCheck(1000) ? "" : "flex-wrap"} flex-center min-w-[600px]`}>
                            <Popover
                                content={
                                    <>
                                        <div className={"flex flex-col gap-2"}>
                                            <Select className="w-100" value={exportType} onChange={(e) => setExportType(e)} placeholder="Sélectionner le format d'exportation">
                                                <Option value="Excel">Excel</Option>
                                                <Option value="CSV">CSV</Option>
                                            </Select>

                                            {rowSelection.selectedRowKeys.length !== 0 && (
                                                <Radio.Group
                                                    buttonStyle="solid"
                                                    value={exportSelected}
                                                    onChange={(e) => setExportSelected(e.target.value)}
                                                >
                                                    <Radio.Button value={false}>Sélectionnés dans le tableau</Radio.Button>
                                                    <Radio.Button value={true}>Sélectionnés manuellement</Radio.Button>
                                                </Radio.Group>
                                            )}

                                            {(exportSelected || rowSelection.selectedRowKeys.length === 0) && (
                                                <>
                                                    <Select
                                                        className="w-100"
                                                        mode="multiple"
                                                        placeholder="Sélectionner le(s) locataire(s)"
                                                        value={selectedRentals}
                                                        onChange={handleRentalChange}
                                                    >
                                                        <Option key="all" value="all">Tous</Option>
                                                        {allRentals.map((rentalCompany, index) => (
                                                            <Option key={index} value={rentalCompany}>{rentalCompany}</Option>
                                                        ))}
                                                    </Select>
                                                    <RangePicker
                                                        format={{ format: 'DD/MM/YYYY', type: 'mask' }}
                                                        presets={rangePresets}
                                                        value={exportRange}
                                                        onChange={(e) => setExportRange(e)}
                                                    />
                                                    <Checkbox
                                                        checked={exportControls}
                                                        onChange={(e) => {setExportControls(e.target.checked)}}
                                                    >
                                                        Avec contrôles nécéssaires uniquement ?
                                                    </Checkbox>
                                                </>
                                            )}
                                        </div>

                                        <div className={"mt-3 flex justify-between"}>
                                            <a className={"my-auto"} onClick={() => handleCloseExportPop()}>Annuler</a>
                                            <Button onClick={() => handleExport()} size={"small"} type={"primary"}>
                                                Exporter
                                            </Button>
                                        </div>
                                    </>
                                }
                                title="Exportation"
                                trigger="click"
                                open={popExportOpen}
                                onOpenChange={(open) => open ? setPopExportOpen(true) : handleCloseExportPop()}
                            >
                                <Button style={{ marginRight: 8 }}>
                                    Exporter
                                </Button>
                            </Popover>
                            <Select
                                className="min-w-60"
                                mode="multiple"
                                placeholder="Sélectionner le(s) locataire(s)"
                                value={selectedDisplayedRentals}
                                onChange={(newSelection) => {
                                    setSelectedDisplayedRentals(newSelection);
                                    handleSearch(search, newSelection);
                                }}
                            >
                                {allRentals.map((rentalCompany, index) => (
                                    <Option key={index} value={rentalCompany}>{rentalCompany}</Option>
                                ))}
                            </Select>
                            <Search
                                placeholder="Recherche"
                                value={search}
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    setSearch(newValue);
                                    handleSearch(newValue, selectedDisplayedRentals);
                                }}
                                enterButton={true}
                                allowClear
                                className="w-max-content"
                            />
                        </div>
                    </div>
                </div>

                <Table
                    rowKey="_id"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={displayedCars}
                    className={"h-max"}
                    size="middle"
                    scroll={{ x: windowDimensions.windowWidth < 900 ? 800 : undefined }}
                    expandable={{
                        expandedRowRender: (record) => (
                            <div>
                                <div className="flex">
                                    <div className="flex flex-col p-1 px-2 space-y-2">
                                        <p><strong>Licence :</strong> {record.license || "-"}</p>
                                        <p><strong>Kilométrage :</strong> {record.miles ? `${record.miles} km` : "-"}</p>
                                        <p><strong>Propriétaire :</strong> {record.owner || "-"}</p>
                                        <p><strong>Locataire :</strong> {record.rentalCompany || "-"}</p>
                                        <p><strong>Contrat de location :</strong> {record.rentalSheet.length !== 0 ? "Oui" : "Non"}</p>
                                        <p><strong>Constat :</strong> {record.report ? "Oui" : "Non"}</p>
                                    </div>
                                    <div className="flex flex-col p-1 ml-24 space-y-2">
                                        <p><strong>Dernière Inspection :</strong> {record.inspection.lastPerformed ? new Date(record.inspection.lastPerformed).toLocaleDateString() : "-" }</p>
                                        <p><strong>Inspection faite par :</strong> {record.inspection.performedBy ? record.inspection.performedBy : "-" }</p>
                                        <p><strong>Dernier contrôle Technique :</strong> {record.technicalReview.lastPerformed ? new Date(record.technicalReview.lastPerformed).toLocaleDateString() : "-" }</p>
                                    </div>
                                    <div className="flex flex-col p-1 ml-24 space-y-2">
                                        {record.availability.description && <p><strong>Description de disponibilité :</strong> {record.availability.description}</p>}
                                        <p><strong>Commentaires :</strong></p>
                                        <ul>
                                            {record.comments?.length > 0 ? (
                                                record.comments
                                                    .slice(-5)
                                                    .map((comment, index) => (
                                                        <li key={index}>
                                                            <strong>{comment.performedBy}</strong> ({new Date(comment.date).toLocaleDateString()}): {comment.description}
                                                        </li>
                                                    ))
                                            ) : (
                                                <li>Aucun commentaire</li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )
                    }}
                />
                <p className={"-mt-9"}>{displayedCars.length} Voitures au total</p>

                {isOpen && (
                    <Modal
                        open={isOpen}
                        onCancel={() => { setIsOpen(false); resetForm(); }}
                        footer={null}
                        width="90%"
                        maxWidth={1100}
                        minWidth={300}
                        maxHeight="95vh"
                        centered
                        className="modal-custom"
                    >
                        <div className="modal-content" style={{ overflowY: 'auto' }}>
                            <div className="modal-header font-bold text-2xl mt-3 mb-5 mx-auto">
                                {elementId ? (elementId === 'view' ? 'VOITURE' : 'MODIFIER UNE VOITURE') : 'AJOUTER UNE VOITURE'}
                            </div>
                            <div className="modal-body px-2">
                                <CarForm
                                    current={currentStep}
                                    setCurrent={setCurrentStep}
                                    newElement={newElement}
                                    setNewElement={setNewElement}
                                    onSubmit={handleElementSubmit}
                                    fileList={fileList}
                                    setFileList={setFileList}
                                    fileListToDelete={fileListToDelete}
                                    setFileListToDelete={setFileListToDelete}
                                />
                            </div>
                            <div className="flex flex-col justify-between mt-6">
                                <div className="flex gap-2 justify-between">
                                    <Button
                                        icon={<CloseOutlined />}
                                        className="rounded-lg w-44"
                                        onClick={() => { setIsOpen(false); resetForm(); }}
                                    >
                                        {elementId === 'view' ? 'Fermer' : 'Annuler'}
                                    </Button>

                                    {elementId === 'view' && (
                                        <div className="flex gap-3">
                                            <Button
                                                icon={<StepBackwardOutlined />}
                                                className="rounded-lg w-44"
                                                onClick={() => setCurrentStep(currentStep - 1)}
                                                disabled={currentStep === 0}
                                            >
                                                Précédent
                                            </Button>
                                            <Button
                                                icon={<StepForwardOutlined />}
                                                type="primary"
                                                onClick={() => setCurrentStep(currentStep + 1)}
                                                className="rounded-lg w-44"
                                                disabled={currentStep >= 3}
                                            >
                                                Suivant
                                            </Button>
                                        </div>
                                    )}

                                    {elementId && elementId !== 'view' && (
                                        <Popconfirm
                                            title="Supprimer la Voiture"
                                            description="Êtes-vous sûr de vouloir le supprimer ?"
                                            okText="Oui"
                                            cancelText="Non"
                                            onConfirm={() => handleElementDelete(elementId)}
                                        >
                                            <Button
                                                icon={<DeleteOutlined />}
                                                type="primary"
                                                danger={true}
                                                className="rounded-lg w-44 ml-auto mr-2"
                                            >
                                                Supprimer
                                            </Button>
                                        </Popconfirm>
                                    )}

                                    {elementId && elementId !== 'view' ? (
                                        <div className="flex gap-3">
                                            <Button
                                                icon={<StepBackwardOutlined />}
                                                className="rounded-lg w-44"
                                                onClick={() => setCurrentStep(currentStep - 1)}
                                                disabled={currentStep === 0}
                                            >
                                                Précédent
                                            </Button>
                                            {currentStep < 3 ? (
                                                <Button
                                                    icon={<StepForwardOutlined />}
                                                    type="primary"
                                                    onClick={() => setCurrentStep(currentStep + 1)}
                                                    className="rounded-lg w-44"
                                                >
                                                    Suivant
                                                </Button>
                                            ) : (
                                                <Popconfirm
                                                    title="Modifier la Voiture"
                                                    description="Êtes-vous sûr de vouloir le modifier ?"
                                                    okText="Oui"
                                                    cancelText="Non"
                                                    onConfirm={handleElementSubmit}
                                                >
                                                    <Button
                                                        icon={<EditOutlined />}
                                                        type="primary"
                                                        className="rounded-lg w-44"
                                                    >
                                                        Modifier
                                                    </Button>
                                                </Popconfirm>
                                            )}
                                        </div>
                                    ) : elementId !== 'view' ? (
                                        <div className="flex gap-3">
                                            <Button
                                                icon={<StepBackwardOutlined />}
                                                className="rounded-lg w-44"
                                                onClick={() => setCurrentStep(currentStep - 1)}
                                                disabled={currentStep === 0}
                                            >
                                                Précédent
                                            </Button>
                                            {currentStep < 3 ? (
                                                <Button
                                                    icon={<StepForwardOutlined />}
                                                    type="primary"
                                                    onClick={() => setCurrentStep(currentStep + 1)}
                                                    className="rounded-lg w-44"
                                                >
                                                    Suivant
                                                </Button>
                                            ) : (
                                                <Popconfirm
                                                    title="Créer la Voiture"
                                                    description="Êtes-vous sûr de vouloir le créer ?"
                                                    okText="Oui"
                                                    cancelText="Non"
                                                    onConfirm={handleElementSubmit}
                                                >
                                                    <Button
                                                        icon={<PlusOutlined />}
                                                        type="primary"
                                                        className="rounded-lg w-44"
                                                    >
                                                        Créer
                                                    </Button>
                                                </Popconfirm>
                                            )}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
}